<template>
  <el-dialog
    title
    :visible.sync="dialogVisible"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1260px"
    custom-class="custom-dialog"
    append-to-body
    @closed="init"
  >
    <div slot="title">
      <el-row>
        <h3 style="text-align:center;margin:10px 0;font-size:18px">
          阿尔法职能模块
          <el-tooltip class="item" effect="dark" :append-to-body="true" placement="right">
            <div slot="content" style="width:500px;line-height:1.5;font-size:14px">
              定义职能模块是阿尔法系统特有的智能匹配实现的第一步； <br />可能有点麻烦，但是做一步会节省后期大量时间；
              <br />定义职能模块是把岗位按照工作职责来分类的做法。同类型的工作职责归类为一个职能模块。
              <br />常用的职能模块包括：HR、机构销售、财务、投行、股票投资、股权投资等。
              <br />以下是我们所有已经定义的职能模块，可以直接点击职能模块名称。如果暂时未包含，可以点击新建，感谢您又为我们系统添砖加瓦。新建的职能模块，我们会通知大行业的负责人，他会做审核，是否变成系统常用的职能模块。
            </div>
            <i class="el-icon-question" style="cursor:pointer;display:inline"></i>
          </el-tooltip>
        </h3>
        <!-- <div style="width:80%;margin:0 auto;font-size:14px">
          <p>定义职能模块是阿尔法系统特有的智能匹配实现的第一步；</p>
          <p>可能有点麻烦，但是做一步会节省后期大量时间；</p>
          <p>定义职能模块是把岗位按照工作职责来分类的做法。同类型的工作职责归类为一个职能模块。</p>
          <p>常用的职能模块包括：HR、机构销售、财务、投行、股票投资、股权投资等。</p>
          <p>以下是我们所有已经定义的职能模块，可以直接点击职能模块名称。如果暂时未包含，可以点击新建，感谢您又为我们系统添砖加瓦。新建的职能模块，我们会通知大行业的负责人，他会做审核，是否变成系统常用的职能模块。</p>
        </div>-->
      </el-row>
    </div>
    <el-container>
      <el-header style="border-bottom:1px solid #eee;">
        <el-row type="flex" align="middle">
          <el-col :span="20">
            <el-autocomplete
              v-model="searchResult"
              :fetch-suggestions="querySearch"
              suffix-icon="el-icon-search"
              placeholder="输入职能模块/细分职能/擅长方向"
              class="cus-autoc"
              size="mini"
            >
              <template slot-scope="{ item }">
                <div @click="selectResult(item)">
                  <div style="font-size:14px">{{ item.label }}</div>
                </div>
              </template>
            </el-autocomplete>
          </el-col>
          <el-col :span="4" style="display:flex;justify-content:flex-end">
            <el-button size="mini" type="primary" style="font-size:14px" @click="createFunction"
              >申请新增职能</el-button
            >
          </el-col>
        </el-row>
      </el-header>
      <el-header v-if="selectedFunction.length > 0" height="auto" style="border-bottom:1px solid #eee;padding:20px">
        <el-row class="mb10" :gutter="6">
          <el-col :span="2" style="font-size:16px"> <b>已选择:</b> </el-col>
          <el-col :offset="18" :span="2">
            <el-button type="primary" size="mini" style="width:100%" @click="submitData">确定</el-button>
          </el-col>
          <el-col :span="2"> <el-button size="mini" style="width:100%" @click="cancel">取消</el-button> </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <div v-for="item in selectedFunction" :key="item.名称" style="display:inline-block">
              <el-tag class="mr10 mb10" closable @close="removeFunction(item.名称)">
                职能模块:
                <el-tag
                  closable
                  size="mini"
                  style="cursor:pointer"
                  class="mr10 mb10"
                  effect="plain"
                  @close="removeFunction(item.名称)"
                  >{{ item.名称 }}</el-tag
                >
                <span v-for="(val, field) in item" :key="field+'1'">
                  <template v-if="field != '名称'">
                    <span v-if="val && val.length > 0">{{ field }}:</span>
                    <el-tag
                      v-for="item1 in val"
                      :key="item1 + field"
                      closable
                      size="mini"
                      style="cursor:pointer"
                      class="mr10 mb10"
                      effect="plain"
                      @close="removeSub(item1, field)"
                      >{{ item1 }}</el-tag
                    >
                  </template>
                </span>
              </el-tag>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container class="mb20" style="padding:20px 0">
        <el-aside style="height:48vh;overflow:scroll" width="200px">
          <el-menu :default-active="curIndustry" :default-openeds="defaultOpeneds" @select="selectIndustries">
            <el-submenu v-for="(hang, da) in industryMap" :key="da" :index="da">
              <template slot="title">
                <span>{{da}}</span>
              </template>
              <el-menu-item v-for="item in hang" :key="item" :index="item">
                {{ item }}
                <el-badge v-if="hasIndustries(item)" class="mark" is-dot />
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main style="height:48vh;overflow:scroll">
          <div class="tag-group">
            <div v-for="(row, rowIdx) in tagRow" :key="rowIdx" class="tag-row">
              <div v-for="(item, idx) in row" :key="idx" style="display:inline-block" class="tag-item">
                <i
                  v-if="idx !== currentItemIdx || rowIdx !== currentRowIdx"
                  class="el-icon-circle-plus"
                  style="color: #303133;cursor:pointer"
                  @click="openRow(rowIdx, idx, item)"
                ></i>
                <i
                  v-else
                  class="el-icon-remove"
                  style="color: #303133;cursor:pointer"
                  @click="closeRow(rowIdx, idx)"
                ></i>
                <el-tag
                  size="medium"
                  style="margin-left:5px;cursor:pointer;border:none;font-size:14px;width:180px;display:inline-flex;justify-content:space-between;align-items:center"
                  class="mr10 mb10 custom-tags"
                  :closable="tagType(item) === 'dark'"
                  :effect="tagType(item)"
                  @close="removeFunction(item, rowIdx, idx)"
                  @click="selectFunction(rowIdx, idx, item)"
                  >{{ item }}</el-tag
                >
              </div>
              <el-card v-if="rowIdx === currentRowIdx" style="width:94%;margin:0 auto 10px;background-color:#ddd">
                <div v-for="(opts, field) in currentDetailData" :key="field">
                  <el-row v-if="field != '名称'">
                    <div style="font-weight:bold">{{field}}:</div>
                    <div v-if="opts.length > 0">
                      <el-tag
                        v-for="(item1, idx1) in opts"
                        :key="idx1"
                        style="margin:5px;cursor:pointer;border:none;font-size:14px"
                        class="custom-tags"
                        size="mini"
                        :closable="subTagType(item1, field) === 'dark'"
                        :effect="subTagType(item1, field)"
                        @close="removeSub(item1, field)"
                        @click="selectSub(item1, field)"
                        >{{ item1 }}</el-tag
                      >
                    </div>
                  </el-row>
                </div>
              </el-card>
            </div>
            <div v-if="resultFunction.length === 0">暂无相关数据~</div>
          </div>
        </el-main>
      </el-container>
      <el-footer height="auto"></el-footer>
    </el-container>
    <createFunction ref="createFunction" @confirmCreate="confirmCreate"></createFunction>
  </el-dialog>
</template>
<script>
import createFunction from './createFunction.vue'
import { cateFieldOnekey, cateFieldMap } from '../../../radish/src/constant/searchFieldsOnekey'

export default {
  components: {
    createFunction,
  },
  filters: {},
  props: {
    single: { type: Boolean, default: false },
  },
  data: function() {
    return {
      dialogVisible: false,
      industryMap: {},
      defaultOpeneds: ['金融', '医药医疗'],
      selectedFunction: [],
      allFunctionData: [],
      searchResult: '',
      curDaIndustry: '金融',
      curIndustry: '公募基金',
      resultFunction: [],
      tagRow: [],
      currentRowIdx: -1,
      currentItemIdx: -1,
      currentDetailData: {
        名称: [],
        细分职能: [],
        擅长方向: [],
      },
      functionData: [],
    }
  },
  watch: {
    curIndustry(val) {
      this.getFunction()
    },
    selectedFunction(val) {},
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.selectedFunction = []
      this.allFunctionData = []
      this.searchResult = ''
      this.curDaIndustry = '金融'
      this.curIndustry = '公募基金'
      this.resultFunction = []
      this.tagRow = []
      this.currentRowIdx = -1
      this.currentItemIdx = -1
      this.currentDetailData = {
        名称: '',
        细分职能: [],
        擅长方向: [],
      }
      const industryMap = {金融: [], 医药医疗: ['医药','医疗器械'], 芯片: []}
      app.industriesAll.forEach(i => {
        const da = i.大行业
        if (!industryMap[da]) industryMap[da] = []
        if (!industryMap[da].includes(i.名称)) industryMap[da].push(i.名称)
      })
      this.industryMap = industryMap
      await this.loadAllFunction()
      this.getFunction()
    },
    createFunction() {
      this.$refs.createFunction.open()
    },
    async confirmCreate(data) {
      await app.getCats()
      this.loadAllFunction()
    },
    selectResult(item) {
      if (item.field == '名称') {
        this.single
          ? (this.selectedFunction = [{ 名称: item.名称 }])
          : this.selectedFunction.every(val => item.名称 !== val) && this.selectedFunction.push({ 名称: item.名称 })
      } else {
        const fuc = { 名称: item.名称 }
        fuc[item.field] = [item.val]
        if (this.single) {
          this.selectedFunction = [fuc]
        } else {
          if (this.selectedFunction.every(val => item.名称 !== val)) {
            this.selectedFunction.push(fuc)
          } else {
            this.selectedFunction = this.selectedFunction.map(s=>{
              if (!s[item.field]) {
                s[item.field] = item.val
              } else {
                s[item.field].push(item.val)
              }
              return s
            })
          }
        }
      }
      for (let i = 0; i < this.functionData.length; i++) {
        if (this.functionData[i].children.includes(item.名称)) {
          this.curIndustry = this.functionData[i].行业
          break
        }
      }
      this.$nextTick(() => {
        const rowIdx = Math.floor(this.resultFunction.indexOf(item.名称) / 4)
        const itemIdx = this.tagRow.indexOf(item.名称)
        this.openRow(rowIdx, itemIdx, item.名称)
      })
    },
    selectIndustries(item) {
      this.curIndustry = item
      this.closeRow()
    },
    async getFunction() {
      const hang = this.functionData.find(val => val.行业 === this.curIndustry)
      if (!hang) {
        this.resultFunction = []
        this.tagRow = []
        this.rowFlag == []
      } else {
        const data = hang.children
        this.resultFunction = data
        const tagRow = new Array(Math.ceil(data.length / 4)).fill(null)
        data.map((ele, idx) => {
          tagRow[Math.floor(idx / 4)] ? tagRow[Math.floor(idx / 4)].push(ele) : (tagRow[Math.floor(idx / 4)] = [ele])
        })
        this.tagRow = tagRow
        this.rowFlag = new Array(tagRow.length).fill(false)
      }
    },
    openRow(rowIdx, idx, item) {
      this.currentRowIdx = rowIdx
      this.currentItemIdx = idx
      this.getDetail(item)
      this.$forceUpdate()
    },
    closeRow() {
      this.currentRowIdx = -1
      this.currentItemIdx = -1
      this.$forceUpdate()
    },
    tagType(name) {
      return this.selectedFunction.some(val => name === val.名称) ? 'dark' : 'plain'
    },
    subTagType(name, type) {
      const fun = this.currentDetailData.名称
      const flag =
        this.selectedFunction.some(val => fun === val.名称) &&
        this.selectedFunction.find(val => val.名称 === fun)[type] &&
        this.selectedFunction.find(val => val.名称 === fun)[type].some(val => val === name)
      return flag ? 'dark' : 'plain'
    },
    hasIndustries(ind) {
      const hang = this.functionData.find(val => val.行业 === ind)
      if (hang) {
        const selectedCate = this.selectedFunction.map(val=>val.名称)
        return hang.children.find(val =>
          selectedCate.includes(val)
        )
      } else {
        return false
      }
    },
    open() {
      this.dialogVisible = true
    },
    selectFunction(rowIdx, idx, item) {
      if (this.selectedFunction.some(val => item === val.名称)) {
        rowIdx === this.currentRowIdx && item === this.currentDetailData.名称
          ? this.closeRow()
          : this.openRow(rowIdx, idx, item)
      } else {
        this.single ? (this.selectedFunction = [{ 名称: item }]) : this.selectedFunction.push({ 名称: item })
        this.openRow(rowIdx, idx, item)
      }
    },
    selectSub(item, type) {
      const fun = this.currentDetailData.名称
      if (this.selectedFunction.every(val => fun != val.名称)) {
        this.single ? (this.selectedFunction = [{ 名称: fun }]) : this.selectedFunction.push({ 名称: fun })
      }
      this.selectedFunction.forEach(ele => {
        if (ele.名称 === fun) {
          if (ele[type] && ele[type].some(val => item === val)) {
            ele[type] = ele[type].filter(val => item !== val)
          } else {
            ele[type] ? ele[type].push(item) : (ele[type] = [item])
          }
        }
      })
      this.$forceUpdate()
    },
    removeFunction(item, rowIdx, idx) {
      this.selectedFunction = this.selectedFunction.filter(val => item !== val.名称)
      this.currentDetailData.名称 === item && this.closeRow()
    },
    removeSub(item, type) {
      const fun = this.currentDetailData.名称
      // console.log(this.selectedFunction)
      this.selectedFunction.map(ele => {
        if (ele.名称 === fun) {
          // console.log(ele, type)
          ele[type] = ele[type].filter(val => item !== val)
        }
      })
      this.$forceUpdate()
    },
    querySearch: async function(queryString, cb) {
      const list = this.allFunctionData
      let results = []
      if (!queryString) {
        results = list.map(l=>{
          return { 名称: l.名称, label: l.名称, field: '名称', val: l.名称  }
        })
      } else {
        list.forEach((l) => {
          if (l.名称 && l.名称.match(new RegExp(queryString, 'i'))) {
            results.push({ 名称: l.名称, label: l.名称, field: '名称', val: l.名称  })
          }
          if (l.二级职能 && l.二级职能.length > 0) {
            l.二级职能.forEach(item=>{
              if (item.match(new RegExp(queryString, 'i'))) {
                results.push(results.push({ 名称: l.名称, label: l.名称 + ' > ' + item, field: '细分职能', val: item  }))
              }
            })
          }
          if (l.擅长方向 && l.擅长方向.length > 0) {
            l.擅长方向.forEach(item=>{
              if (item.match(new RegExp(queryString, 'i'))) {
                results.push(results.push({ 名称: l.名称, label: l.名称 + ' > ' + item, field: '擅长方向', val: item  }))
              }
            })
          }
        })
      }
      return cb(results)
    },
    loadAllFunction: async function() {
      if (!app.categories) await app.getCats()
      this.allFunctionData = JSON.parse(JSON.stringify(app.categories))
      const obj = {}
      app.categories.forEach(cate=>{
        if(Array.isArray(cate.类型) && cate.类型.length > 0) {
          cate.类型.forEach(hangye=>{
            if (!obj[hangye]) {
              obj[hangye] = { 行业: hangye, children: [cate.名称] }
            } else {
              obj[hangye].children.push(cate.名称)
            }
          })
        } else {
          if (!obj.通用) {
            obj.通用 = { 行业: '通用', children: [cate.名称] }
          } else {
            obj.通用.children.push(cate.名称)
          }
        }
      })
      this.functionData = Object.values(obj)
    },
    submitData() {
      const submitData = this.selectedFunction
      if (submitData.length === 0) {
        this.$message({
          message: '请选择至少一个职能模块',
          type: 'warning',
        })
        return
      }
      this.$emit('confirm', submitData)
      this.dialogVisible = false
      this.selectedFunction = []
      this.init()
    },
    cancel() {
      this.dialogVisible = false
      this.selectedFunction = []
      this.init()
    },
    getDetail(item) {
      const cateData = app.categories
      const cate = cateData.find(ele => ele.名称 === item)
      const currentDetailData = {}
      currentDetailData.细分职能 = cate['二级职能'] || []
      currentDetailData.擅长方向 = cate['擅长方向'] || []
      currentDetailData.名称 = item
      if (item.indexOf('医疗-') !== -1) {
        currentDetailData['医疗科室'] = cateFieldOnekey['医疗科室'].options
      } else if (item.indexOf('工业-') !== -1) {
        currentDetailData['业务方向'] = cateFieldOnekey['业务方向'].options
      } else if (cate.类型 && cate.类型.includes('芯片设计')) {
        currentDetailData['是否量产'] = cateFieldOnekey['是否量产'].options
        currentDetailData['是否流片'] = cateFieldOnekey['是否流片'].options
      } else if (cate.类型 && cate.类型.includes('猎头')) {
        currentDetailData['擅长职能'] = cateFieldOnekey['擅长职能'].options
        currentDetailData['团队业绩'] = cateFieldOnekey['团队业绩'].options
        currentDetailData['开票业绩'] = cateFieldOnekey['开票业绩'].options
        currentDetailData['擅长职位'] = cateFieldOnekey['擅长职位'].options
        currentDetailData['客户资源'] = cateFieldOnekey['客户资源'].options
      } else if (cateFieldMap[item]) {
        cateFieldMap[item].forEach(field=>{
          currentDetailData[field] = cateFieldOnekey[field].options
        })
      }
      this.currentDetailData = currentDetailData
    },
  },
}
</script>
<style scoped src="../../statistics/css/hunting.css">

</style>
<style scoped>
.custom-dialog {
  margin-top: 8vh !important;
}

.custom-dialog .el-dialog__body {
  padding-top: 15px;
  padding-bottom: 0;
}

.cus-autoc .el-input {
  font-size: 14px !important;
}

.custom-tags {
  color: #303133;
}

.custom-tags.el-tag--dark {
  color: #fff;
}

.custom-tags.el-tag--dark:hover {
  color: #fff;
}

.custom-tags:hover {
  color: #409eff;
}

.tag-item:hover>i {
  color: #409eff !important;
}
</style>
<style scoped>
.custom-dialog .el-dialog__body {
  padding-top: 15px;
}
</style>
